export const typeTagMap = {
  letter: `Lettre ouverte`,
  theme: `Dossier thématique`,
  opinion: `Texte d'opinion`,
  balado: `Balado`,
  article: `Article`,
  event: `Événement`,
  news: `Nouvelle`,
  page: `Page du site`,
  monitoring: `Veille informationnelle`,
  project: `Projet`,
  report: `Rapport`,
  memoir: `Mémoire et avis`,
  annual: `Rapport annuel`,
  newsletter: `Infolettre`,
  declaration: `Déclaration`
}

export const typeIconMap = {
  letter: `content-file`,
  theme: `content-folder`,
  opinion: `content-declaration`,
  balado: `content-podcast`,
  article: `content-article`,
  event: `bullet-events`,
  news: `content-news`,
  page: `content-page`,
  monitoring: `bullet-analyse`,
  project: `content-project`,
  report: `content-list`,
  memoir: `content-chat`,
  annual: `content-date`,
  newsletter: `content-mail`,
  declaration: `content-declaration`
}

export const eventTypeTagMap = {
  webinar: 'Webinaire',
  workshop: 'Atelier',
  forum: 'Forum',
  award: 'Remise de prix',
  seminar: 'Séminaire',
  study: 'Journée d’étude',
  assembly: 'Assemblée générale',
  launch: 'Lancement',
  consultation: 'Consultation',
  event: `Événement`
}

export const eventTypeIconMap = {
  webinar: 'content-web',
  workshop: 'content-list',
  forum: 'content-forum',
  award: 'content-trophy',
  seminar: 'content-edifice',
  study: 'icon-book',
  assembly: 'bullet-people',
  launch: 'content-zoom-out',
  consultation: 'content-business',
  event: `bullet-events`
}
